import { render, staticRenderFns } from "./PelatihanUjianPilihan.vue?vue&type=template&id=1a52c160"
import script from "./PelatihanUjianPilihan.vue?vue&type=script&lang=js"
export * from "./PelatihanUjianPilihan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports